export { load } from '@progress/kendo-intl';
